import { useState, useEffect } from 'react'
import { parse } from 'papaparse'
import { Toaster } from '@ui'

export interface IImportMapping {
  id: number
  siq: string | null
  csv: string
}

export default function useFileReader(initMappings: (fileColumns: string[]) => void) {
  const [file, setFile] = useState<File | null>(null)
  const [fileContent, setFileContent] = useState<string>('')
  const [parsedContent, setParsedContent] = useState<Array<any>[]>([])

  useEffect(() => {
    if (file) {
      parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: ({ data, meta }) => {
          setParsedContent(data as any[])
          initMappings(meta.fields as string[])
        },
      })

      const reader = new FileReader()
      reader.addEventListener('load', (e) => setFileContent(e.target?.result as string))
      reader.addEventListener('error', () => {
        Toaster.fail({ message: 'Oops, something went wrong...' })
      })
      reader.readAsDataURL(file)
    }
  }, [file, initMappings])

  return {
    file,
    setFile,
    fileContent,
    parsedContent,
  }
}
